<template>
  <div class="login-vue" :style="bg" v-if="loginFlags">
    <div class="container">
      <p class="title" style="font-size: 20px;">绿居物业</p>
      <!-- <img src="../assets/imgs/logo.png" style="width: 200px; margin-bottom: 20px" alt="logo" class="logo" /> -->
      <el-form ref="form" :model="loginData" label-width="60px" label-position="center" :hide-required-asterisk="true"
        :rules="rules">
        <!-- <el-form-item label="租户ID" prop="tenant">
          <el-input
            v-model="loginData.tenant"
            placeholder="请输入租户ID"
            clearable
            ref="userName"
          >
            <i
              slot="prefix"
              class="iconfont icon-xingmingyonghumingnicheng"
            ></i>
          </el-input>
        </el-form-item> -->
        <el-form-item label="账号" prop="accout">
          <el-input v-model="loginData.accout" placeholder="请输入用户名" clearable ref="userName">
            <i slot="prefix" class="iconfont icon-xingmingyonghumingnicheng"></i>
          </el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginData.password" show-password placeholder="请输入密码" clearable>
            <i slot="prefix" class="iconfont icon-mima1"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-row :span="24">
            <el-col :span="14" style="margin-right: 20px">
              <el-input @keyup.enter.native="submit" v-model="loginData.code" auto-complete="off" placeholder="请输入验证码">
                <i slot="prefix" class="iconfont icon-mima"></i>
              </el-input>
            </el-col>
            <el-col :span="8">
              <div class="login-code">
                <img :src="image" class="login-code-img" @click="getCode" />
              </div>
            </el-col>
          </el-row>
        </el-form-item>

        <el-button :loading="isShowLoading" class="submit" type="primary" @click="submit">登录</el-button>
        <!-- <p class="account"><span>注册账号</span> | <span>忘记密码</span></p> -->
      </el-form>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="forms" :rules="rulesPass" label-width="300px" label-position="center">
        <el-form-item label="密码" :label-width="formLabelWidth" prop="passWord">
          <el-input type="password" clearable show-password v-model="form.passWord" autocomplete="off">
            <i slot="prefix" class="iconfont icon-mima1"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="passWords">
          <el-input type="password" show-password clearable v-model="form.passWords" autocomplete="off">
            <i slot="prefix" class="iconfont icon-mima1"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="pswSummit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import reg from "@/utils/reg";
import AES from "@/utils/aes";
export default {
  name: "login",
  data() {
    return {
      loginData: {
        tenant: "",
        account: "",
        pwd: "",
        code: "",
      },
      rules: {
        // tenant: [{ required: true, message: "请输入租户ID", trigger: "blur" }],
        accout: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          //   { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          //   { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          //   { min: 5, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      rulesPass: {
        passWord: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (!reg.passWord(value)) {
                callback(
                  new Error("须包含大写(小写)字母和数字,长度在8到16个字符")
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        passWords: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (!reg.passWord(value)) {
                callback(
                  new Error("须包含大写(小写)字母和数字,长度在8到16个字符")
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      image:
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      isShowLoading: false,
      bg: {},
      dialogFormVisible: false,
      formLabelWidth: "120px",
      form: {},
      loginFlags: false,
    };
  },
  created() { },
  mounted() {
    let that = this;
    let openr = window.opener;
    if (openr) {
      localStorage.clear();
      openr.postMessage("", process.env.VUE_APP_HGJURL);
      window.addEventListener("message", function (event) {
        // event.origin判断好管家地址 event.data是好管家传来的code
        if (event.origin == process.env.VUE_APP_HGJURL) {
          let code = event.data;
          console.log(code)
          that.loginFlags = false;
          localStorage.setItem("loginFlags", false);
          that.clientUserddLogin(code);
        } else {
          localStorage.setItem("loginFlags", true);
          that.loginFlags = true;
          that.getCode();
        }
      });
    } else {
      localStorage.setItem("loginFlags", true);
      that.loginFlags = true;
      // 判断是否能够获取到token
      if (window.localStorage.getItem("zhi_token") || this.token) {
        this.$router.push({ path: this.redirect || "/" });
        return;
      }
      this.bg.backgroundImage =
        "url(" + require("../assets/imgs/background-black.jpg") + ")";
      that.getCode();
    }
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },

  methods: {
    // 好管家免登
    clientUserddLogin(code) {
      let data = {
        code,
      };
      this.$Apis.userDDlogin(data).then((res) => {
        if (res.code == 200) {
          let result = res.data ? JSON.parse(res.data) : {}
          if (result.code == 200) {
            let { id, nickname, roleName, token, account, headUrl } = result.data;
            localStorage.setItem("zhi_token", token);
            localStorage.setItem(
              "ToUserInfo",
              JSON.stringify({ id, nickname, roleName, token, account, headUrl })
            );
            this.$store.commit("setToken", token);
            this.$store.commit("setUserInfo", {
              id,
              nickname,
              roleName,
              token,
              account,
              headUrl,
            });
            this.getMENU();
          } else {
            this.$message.warning(result.msg);
          }
        } else {
          this.$message.warning(res.msg);
        }

      });
    },
    // 修改密码
    pswSummit() {
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          if (this.form.passWord == this.form.passWords) {
            var data = {
              accout: this.loginData.accout,
              passWord: this.form.passWords,
            };
            this.$Apis.updatePassWord(data).then((res) => {
              if (res.code == 200) {
                this.$message.success("修改成功,请重新登陆!");
                this.dialogFormVisible = false;
                this.loginData.password = "";
                this.loginData.code = "";
              } else {
                this.$message.warning(res.msg);
              }
            });
          } else {
          }
        }
      });
    },
    // 获取验证码
    getCode() {
      this.$Apis.getVerification().then((res) => {
        if (res.code == 200) {
          let { image, key } = res.data;
          this.image = image;

          localStorage.setItem("ToUserVerificationCodeKey", key);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 小区列表
    parkList() {
      console.log('12313131',1231231)
      this.$Apis.villageListAll().then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            localStorage.setItem("park_data", JSON.stringify(res.data[0]));
          }
          // if (this.redirect) {
          //   console.log(this.redirect)
          //   this.$router.push({ path: this.redirect });
          // } else {
            const menuLists = JSON.parse(localStorage.getItem("ToMenuitems"));
            let paths = "login",
              title = "登录";
            console.log(menuLists);
            if (menuLists && menuLists.length > 0) {
              if (menuLists[0].children && menuLists[0].children.length > 0) {
                menuLists[0].children.forEach((res, ind) => {
                  if (res.children && res.children.length > 0) {
                    paths = res.children[0].name;
                    title = res.children[0].text;
                  } else {
                    paths = menuLists[0].children[0].name;
                    title = menuLists[0].children[0].text;
                  }
                });
              } else {
                paths = menuLists[0].name;
                title = menuLists[0].text;
              }
            }
            console.log(paths)
            this.$router.push({ path: "/" + paths });
            //  window.location.reload();
          // }
        }
      });
    },
    // 获取菜单
    getMENU() {
      //  获取菜单信息存入 vuex中
      this.$Apis.getMenuData().then((res) => {
        if (res.code == 200) {
          var menuItems = [];
          menuItems.length = res.data.length;
          for (let i = 0; i < menuItems.length; i++) {
            let data = res.data[i];
            menuItems[i] = {};
            if (data.children.length == 0) {
              menuItems[i].name = data.path;
            }
            menuItems[i].type = data.icon;
            menuItems[i].text = data.name;

            if (data.children.length > 0) {
              menuItems[i].children = [];
              for (let j = 0; j < data.children.length; j++) {
                menuItems[i].children.push({
                  type: data.children[j].icon,
                  name: data.children[j].path,
                  text: data.children[j].name,
                });
              }
            }
          }
          this.$store.commit("setMenus", menuItems);
          localStorage.setItem("ToMenuitems", JSON.stringify(menuItems));
          this.parkList();
        }
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.isShowLoading = true;
          let data = {
            tenant: this.loginData.tenant || "541732",
            account: AES.encrypt(
              this.loginData.accout,
              ""
            ),
            password: AES.encrypt(
              this.loginData.password,
              ""
            ),
            code: this.loginData.code,
          };
          this.$Apis.loginIn(data).then((res) => {
            this.isShowLoading = false;
            if (res.code == 200) {
              if (this.loginData.password == "Abc12345+") {
                this.$message({
                  message: "密码为重置密码,请修改密码！",
                  type: "warning",
                });
                setTimeout(() => {
                  this.dialogFormVisible = true;
                }, 300);
                return;
              } else {
                this.$message({
                  message: "登录成功",
                  type: "success",
                });
                let { id, nickname, roleName, token, account, headUrl } =
                  res.data;
                localStorage.setItem("zhi_token", token);
                localStorage.setItem(
                  "ToUserInfo",
                  JSON.stringify({ id, nickname, roleName, account, headUrl })
                );
                this.$store.commit("setToken", token);
                this.$store.commit("setUserInfo", {
                  id,
                  nickname,
                  roleName,
                  account,
                  headUrl,
                });
                this.getMENU();
              }
            } else {
              this.getCode();
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style>
.el-form-item__label {
  text-align: center !important;
}

.login-vue {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* background: url("http://www.17sucai.com/preview/242158/2015-01-10/%E7%99%BB%E5%BD%95/images/cloud.jpg")   0 bottom repeat-x #049ec4;   */
  animation: animate-cloud 20s linear infinite;
}

.login-vue .container {
  background: rgba(255, 255, 255, 0.5);
  min-width: 500px;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
  /* margin-right: 220px; */
}

.login-vue .ivu-input {
  background-color: transparent;
  color: #fff;
  outline: #fff;
  border-color: #fff;
}

.login-vue ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: rgba(255, 255, 255, 0.8);
}

.login-vue :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 0.8);
}

.login-vue ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 0.8);
}

.login-vue :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 0.8);
}

.login-vue .title {
  font-size: 16px;
  margin-bottom: 20px;
}

.login-vue .input-c {
  margin: auto;
  width: 200px;
}

.login-vue .error {
  color: red;
  text-align: left;
  margin: 5px auto;
  font-size: 12px;
  padding-left: 30px;
  height: 20px;
}

.login-vue .submit {
  width: 200px;
}

.login-vue .account {
  margin-top: 30px;
}

.login-vue .account span {
  cursor: pointer;
}

.login-vue .ivu-icon {
  color: #eee;
}

.login-vue .ivu-icon-ios-close-circle {
  color: #777;
}

.login-code-img {
  cursor: pointer;
}
</style>